import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { endpoints } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { BaseResult } from '../../shared/models/base.result.model';
import { PixTransferRequest } from './models/transfer-request.model';
import { PixDevolutionRequest } from './models/devolution-request.mode';

@Injectable()
export class PixService {
	private url = endpoints.pix;
	private pixTransferRequest: PixTransferRequest;

	constructor(private http: HttpClient) { }

	getNotifications(
		inicial: string,
		dataHoraInicial: string,
		dataHoraFinal: string,
		quantidade: string,
		tiposNotificacao: string): Observable<any> {
			return this.http.get(`${this.url.notifications}?
				inicial=${inicial}&
				dataHoraInicial=${dataHoraInicial}&
				dataHoraFinal=${dataHoraFinal}&
				quantidade=${quantidade}&
				tiposNotificacao=${tiposNotificacao}`);
	}


	setPixTransferRequest(pixTransferRequest: PixTransferRequest) {
		this.pixTransferRequest = pixTransferRequest;
	}

	getPixTransferRequest(): PixTransferRequest {
		return this.pixTransferRequest;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/pix.service.ts